var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLowerThan = function SvgLowerThan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.563 11.756.17 6.407a.572.572 0 0 1 0-.814L5.563.244a.848.848 0 0 1 1.19 0 .829.829 0 0 1 0 1.18L2.14 6l4.614 4.575a.83.83 0 0 1 0 1.18.846.846 0 0 1-1.19 0",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};

export default SvgLowerThan;